import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const miPipOption6: TaskDefinition = {
  taskName: onboardingTasks.ProofOfMIPipOption6,
  config: {
    staffDisplayName: 'Provide proof of MI PIP medical limit eligibility',
    appcuesModalId: '8c926e7b-771d-429f-b530-93d03dc639e9',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of MI PIP Option 6',
    account: {
      toastMessage: 'Your proof of Medicare coverage documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Provide proof of MI PIP medical limit eligibility',
        incompleteSubtitle:
          'Confirm your eligibility for opting out of Personal Injury Protection (PIP) medical coverage by submitting proof of eligibility documents.',
        completedSubtitle: `You've successfully submitted your proof of eligibility for the current Personal Injury Protection (PIP) medical limit on ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of Medicare coverage',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: 'To opt out of PIP medical coverage, you or the member will need to provide:'
          },
          {
            title: null,
            body: [
              'Proof of Medicare parts A & B, or Medicare Advantage, for the primary applicant',
              'Proof of Medicare parts A & B, Medicare Advantage, Qualified Health Coverage (QHC), or PIP coverage through another MI auto policy for all other household residents.'
            ],
            isList: true
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in the documents listed above. Without these documents, we'll return the policy's limit to the unlimited default, which will impact the price.`
          }
        ]
      })
    }
  }
};
